import { createSlice } from "@reduxjs/toolkit";
import { pushDynamicTab } from "../utils/dynamicTabs";

// 🔹 Current version of the slice
const SLICE_VERSION = "1.0";

// 🔹 Exported initial state for store.js version check
export const initialState = {
  _version: SLICE_VERSION,
  defaultTabs: [
    { id: "my-inventory", name: "My Inventory" },
    { id: "analytics-inventory", name: "Analytics" },
    { id: "restock-alerts", name: "Restock Alerts" },
    { id: "templates-inventory", name: "Templates" },
    { id: "drafts-inventory", name: "Drafts" },
  ],
  dynamicTabs: [],
  activeTab: 0,
};

// 🔹 Inventory slice definition
const inventorySlice = createSlice({
  name: "inventory",
  initialState,
  reducers: {
    addTab: (state, action) => {
      let tabDetails;

      if (action.payload) {
        tabDetails = action.payload;
      } else {
        const dynamicId =
          window.crypto?.randomUUID?.() ||
          `${Date.now()}-${Math.random().toString(36).slice(2, 15)}-${state.dynamicTabs.length}`;
        tabDetails = {
          id: `dyn-${dynamicId}`,
          name: `New Inventory ${state.dynamicTabs.length + 1}`,
          isDynamic: true,
          createdAt: Date.now(),
        };
      }

      pushDynamicTab(state, tabDetails, state.defaultTabs.length);
    },

    removeTab: (state, action) => {
      const { tabIndex } = action.payload;
      if (tabIndex < state.defaultTabs.length) return;

      const dynamicIndex = tabIndex - state.defaultTabs.length;
      state.dynamicTabs.splice(dynamicIndex, 1);
      state.activeTab = Math.min(
        state.activeTab,
        state.defaultTabs.length + state.dynamicTabs.length - 1
      );
    },

    setActiveTab: (state, action) => {
      const { index } = action.payload;
      const totalTabs = state.defaultTabs.length + state.dynamicTabs.length;
      if (index >= 0 && index < totalTabs) {
        state.activeTab = index;
      }
    },

    resetTabs: (state) => {
      state.dynamicTabs = [];
      state.activeTab = 0;
    },
  },
});

// 🔹 Export actions and reducer
export const { addTab, removeTab, setActiveTab, resetTabs } = inventorySlice.actions;
export default inventorySlice.reducer;
